import isEmail from 'validator/es/lib/isEmail';
import isMobilePhone from 'validator/es/lib/isMobilePhone';
import isURL from 'validator/es/lib/isURL';
import { translatorFactory } from '@assetsJsModule/i18next-react';
import getValidationError from '@assetsJsModule/dropzone/service/getValidationError';
import { FORM_VACANCY_NAMES } from '../config/constants';
import { MAX_FILE_SIZE, MAX_TOTAL_FILES_SIZE, ALLOWED_MIME_TYPES } from '../../shared/config/constants';

const validate = (values) => {
    const t = translatorFactory('PayseraRecruitmentBundle');

    const errors = {};

    if (!values[FORM_VACANCY_NAMES.FIRST_NAME] || !values[FORM_VACANCY_NAMES.FIRST_NAME].trim()) {
        errors[FORM_VACANCY_NAMES.FIRST_NAME]  = t('apply_form.validate.required');
    }

    if (values[FORM_VACANCY_NAMES.FIRST_NAME]) {
        if (values[FORM_VACANCY_NAMES.FIRST_NAME].length < 2) {
            errors[FORM_VACANCY_NAMES.FIRST_NAME] = t('apply_form.validate.short_2');
        }

        if (values[FORM_VACANCY_NAMES.FIRST_NAME].length > 20) {
            errors[FORM_VACANCY_NAMES.FIRST_NAME] = t('apply_form.validate.long_20');
        }
    }

    if (!values[FORM_VACANCY_NAMES.LAST_NAME] || !values[FORM_VACANCY_NAMES.LAST_NAME].trim()) {
        errors[FORM_VACANCY_NAMES.LAST_NAME] = t('apply_form.validate.required');
    }

    if (values[FORM_VACANCY_NAMES.LAST_NAME]) {
        if (values[FORM_VACANCY_NAMES.LAST_NAME].length < 2) {
            errors[FORM_VACANCY_NAMES.LAST_NAME] = t('apply_form.validate.short_2');
        }

        if (values[FORM_VACANCY_NAMES.LAST_NAME].length > 29) {
            errors[FORM_VACANCY_NAMES.LAST_NAME] = t('apply_form.validate.long_29');
        }
    }

    if (!values[FORM_VACANCY_NAMES.EMAIL] || !values[FORM_VACANCY_NAMES.EMAIL].trim()) {
        errors[FORM_VACANCY_NAMES.EMAIL] = t('apply_form.validate.required');
    }

    if (values[FORM_VACANCY_NAMES.EMAIL] && !isEmail(values[FORM_VACANCY_NAMES.EMAIL])) {
        errors[FORM_VACANCY_NAMES.EMAIL] = t('apply_form.validate.not_valid');
    }

    if (!values[FORM_VACANCY_NAMES.PHONE]?.trim() || !isMobilePhone(values[FORM_VACANCY_NAMES.PHONE])) {
        errors[FORM_VACANCY_NAMES.PHONE] = t('apply_form.validate.not_valid');
    }

    if (!values[FORM_VACANCY_NAMES.ENGLISH_LEVEL]) {
        errors[FORM_VACANCY_NAMES.ENGLISH_LEVEL] = t('apply_form.validate.required');
    }

    if (!values[FORM_VACANCY_NAMES.COUNTRY]) {
        errors[FORM_VACANCY_NAMES.COUNTRY] = t('apply_form.validate.required');
    }

    // make CV optional temporarily, https://jira.paysera.net/browse/FRNT-431
    // if (!values[FORM_VACANCY_NAMES.CV] || !values[FORM_VACANCY_NAMES.CV].length) {
    //     errors[FORM_VACANCY_NAMES.CV] = t('apply_form.validate.required');
    // }

    const cvValidationError = getValidationError(
        values[FORM_VACANCY_NAMES.CV] || [],
        MAX_FILE_SIZE,
        MAX_TOTAL_FILES_SIZE,
        ALLOWED_MIME_TYPES,
    );

    if (cvValidationError !== null) {
        errors[FORM_VACANCY_NAMES.CV] = cvValidationError;
    }

    if (values[FORM_VACANCY_NAMES.LINKEDIN]) {
        if (!isURL(values[FORM_VACANCY_NAMES.LINKEDIN])) {
            errors[FORM_VACANCY_NAMES.LINKEDIN] = t('apply_form.validate.not_valid');
        }

        if (values[FORM_VACANCY_NAMES.LINKEDIN].length > 200) {
            errors[FORM_VACANCY_NAMES.LINKEDIN] = t('apply_form.validate.long_200');
        }
    }

    if (values[FORM_VACANCY_NAMES.INFORMATION] && values[FORM_VACANCY_NAMES.INFORMATION].length > 5000) {
        errors[FORM_VACANCY_NAMES.INFORMATION] = t('apply_form.validate.long_5000');
    }

    if (values[FORM_VACANCY_NAMES.SUBMIT_TASK] && values[FORM_VACANCY_NAMES.SUBMIT_TASK].length > 5000) {
        errors[FORM_VACANCY_NAMES.SUBMIT_TASK] = t('apply_form.validate.long_5000');
    }

    if (!values[FORM_VACANCY_NAMES.PRIVACY_POLICY]) {
        errors[FORM_VACANCY_NAMES.PRIVACY_POLICY] = t('apply_form.validate.required');
    }

    if (!values[FORM_VACANCY_NAMES.NAME_OF_AGENCY] || !values[FORM_VACANCY_NAMES.NAME_OF_AGENCY].trim()) {
        errors[FORM_VACANCY_NAMES.NAME_OF_AGENCY] = t('apply_form.validate.required');
    }

    if (values[FORM_VACANCY_NAMES.NAME_OF_AGENCY]) {
        if (values[FORM_VACANCY_NAMES.NAME_OF_AGENCY].length < 2) {
            errors[FORM_VACANCY_NAMES.NAME_OF_AGENCY] = t('apply_form.validate.short_2');
        }

        if (values[FORM_VACANCY_NAMES.NAME_OF_AGENCY].length > 54) {
            errors[FORM_VACANCY_NAMES.NAME_OF_AGENCY] = t('apply_form.validate.long_54');
        }
    }

    if (!values[FORM_VACANCY_NAMES.AGENCY_ID] || !values[FORM_VACANCY_NAMES.AGENCY_ID].trim()) {
        errors[FORM_VACANCY_NAMES.AGENCY_ID] = t('apply_form.validate.required');
    }

    if (values[FORM_VACANCY_NAMES.AGENCY_ID]) {
        if (values[FORM_VACANCY_NAMES.AGENCY_ID].length < 2) {
            errors[FORM_VACANCY_NAMES.AGENCY_ID] = t('apply_form.validate.short_2');
        }

        if (values[FORM_VACANCY_NAMES.AGENCY_ID].length > 20) {
            errors[FORM_VACANCY_NAMES.AGENCY_ID] = t('apply_form.validate.long_20');
        }
    }

    if (!values[FORM_VACANCY_NAMES.AGENCY_EMAIL] || !values[FORM_VACANCY_NAMES.AGENCY_EMAIL].trim()) {
        errors[FORM_VACANCY_NAMES.AGENCY_EMAIL] = t('apply_form.validate.required');
    }

    if (values[FORM_VACANCY_NAMES.AGENCY_EMAIL] && !isEmail(values[FORM_VACANCY_NAMES.AGENCY_EMAIL])) {
        errors[FORM_VACANCY_NAMES.AGENCY_EMAIL] = t('apply_form.validate.not_valid');
    }

    if (!values[FORM_VACANCY_NAMES.CONTACT_PERSON] || !values[FORM_VACANCY_NAMES.CONTACT_PERSON].trim()) {
        errors[FORM_VACANCY_NAMES.CONTACT_PERSON] = t('apply_form.validate.required');
    }

    if (values[FORM_VACANCY_NAMES.CONTACT_PERSON]) {
        if (values[FORM_VACANCY_NAMES.CONTACT_PERSON].length < 2) {
            errors[FORM_VACANCY_NAMES.CONTACT_PERSON] = t('apply_form.validate.short_2');
        }

        if (values[FORM_VACANCY_NAMES.CONTACT_PERSON].length > 54) {
            errors[FORM_VACANCY_NAMES.CONTACT_PERSON] = t('apply_form.validate.long_54');
        }
    }

    if (values[FORM_VACANCY_NAMES.AGENCY_FEEDBACK] && values[FORM_VACANCY_NAMES.AGENCY_FEEDBACK].length > 5000) {
        errors[FORM_VACANCY_NAMES.AGENCY_FEEDBACK] = t('apply_form.validate.long_5000');
    }

    return errors;
};

export default validate;
